// Date 2021-06-28 18:04:55

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import emSicEafmREocEmrecEdit from "@/views/em/statusCollection/EmSicEafmREocEmrecEdit.vue";
import emSicEafmREocEmrecList from "@/views/em/statusCollection/EmSicEafmREocEmrecList.vue";
import emSicDowntimeRecordSdrList from "@/views/em/statusCollection/EmSicDowntimeRecordSdrList";
import emSicDowntimeRecordSdrEdit from "@/views/em/statusCollection/EmSicDowntimeRecordSdrEdit";
import imfEmSicEqStatusMoniRecoIesmrList from "@/views/em/statusCollection/ImfEmSicEqStatusMoniRecoIesmrList.vue";
import imfEmSicEqStatusMoniRecoIesmrEdit from "@/views/em/statusCollection/ImfEmSicEqStatusMoniRecoIesmrEdit.vue";
import emSicBackgroundImageSbiList from "@/views/em/statusCollection/EmSicBackgroundImageSbiList";
import emSicBackgroundImageSbiEdit from "@/views/em/statusCollection/EmSicBackgroundImageSbiEdit";
import emSicCustomizedDiagramScdEdit from "@/views/em/statusCollection/EmSicCustomizedDiagramScdEdit";
import emSicCustomizedDiagramScdList from "@/views/em/statusCollection/EmSicCustomizedDiagramScdList";
import emSicCustomizedDiagramPieceCdpList from "@/views/em/statusCollection/EmSicCustomizedDiagramPieceCdpList";
import emSicCustomizedDiagramPieceCdpEdit from "@/views/em/statusCollection/EmSicCustomizedDiagramPieceCdpEdit";
import tpmMonitorSpindleLoadTmsList from "@/views/em/statusCollection/TpmMonitorSpindleLoadTmsList.vue";
import tpmMonitorSpindleLoadTmsEdit from "@/views/em/statusCollection/TpmMonitorSpindleLoadTmsEdit.vue";
import tpmMonitorProgramStatusTmpList from "@/views/em/statusCollection/TpmMonitorProgramStatusTmpList.vue";
import tpmMonitorProgramStatusTmpEdit from "@/views/em/statusCollection/TpmMonitorProgramStatusTmpEdit.vue";
import tpmOeeReportTorEdit from "@/views/em/statusCollection/TpmOeeReportTorEdit.vue";
import tpmOeeReportTorList from "@/views/em/statusCollection/TpmOeeReportTorList.vue";
import tpmOeeSpindleDataFetchEdit from "@/views/em/statusCollection/TpmOeeSpindleDataFetchEdit.vue";
import tpmOeeSpindleDataFetchList from "@/views/em/statusCollection/TpmOeeSpindleDataFetchList.vue";
import tpmOeeQueryHistoryTohEdit from "@/views/em/statusCollection/TpmOeeQueryHistoryTohEdit.vue";
import tpmOeeQueryHistoryTohList from "@/views/em/statusCollection/TpmOeeQueryHistoryTohList.vue";
import tpmOeeDashboardConfigList from "@/views/em/statusCollection/TpmOeeDashboardConfigList.vue";
import tpmOeeDashboardConfigEdit from "@/views/em/statusCollection/TpmOeeDashboardConfigEdit.vue";
import tpmMonitorOperateModeTmoList from "@/views/em/statusCollection/TpmMonitorOperateModeTmoList.vue";
import tpmMonitorOperateModeTmoEdit from "@/views/em/statusCollection/TpmMonitorOperateModeTmoEdit.vue";
import tpmMonitorProgramStatusTmoEdit from "@/views/em/statusCollection/TpmMonitorProgramStatusTmoEdit.vue";
import tpmMonitorProgramStatusTmoList from "@/views/em/statusCollection/TpmMonitorProgramStatusTmoList.vue";
import tpmAxisCoordinateDataAcdList from "@/views/em/statusCollection/TpmAxisCoordinateDataAcdList.vue";
import tpmAxisCoordinateDataAcdEdit from "@/views/em/statusCollection/TpmAxisCoordinateDataAcdEdit.vue";
import tpmTsdOpcConfigTtcEdit from "@/views/em/statusCollection/TpmTsdOpcConfigTtcEdit.vue";
import tpmTsdOpcConfigTtcList from "@/views/em/statusCollection/TpmTsdOpcConfigTtcList.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/statusCollection/emSicMonitorPointSmp/list",
        name: "emSicMonitorPointSmpList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicMonitorPointSmp/edit",
        name: "emSicMonitorPointSmpEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicUploadFileSuf/list",
        name: "emSicUploadFileSufList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicUploadFileSuf/edit",
        name: "emSicUploadFileSufEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBoardModuleSdm/list",
        name: "emSicBoardModuleSdmList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBoardModuleSdm/edit",
        name: "emSicBoardModuleSdmEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBoardPointSdp/list",
        name: "emSicBoardPointSdpList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBoardPointSdp/edit",
        name: "emSicBoardPointSdpEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBoardLifeCycleSdl/list",
        name: "emSicBoardLifeCycleSdlList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBoardLifeCycleSdl/edit",
        name: "emSicBoardLifeCycleSdlEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfSicEquipmentInfoIsei/list",
        name: "imfSicEquipmentInfoIseiList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfSicEquipmentInfoIsei/edit",
        name: "imfSicEquipmentInfoIseiEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfEmSicIesmrReasonIesmrr/list",
        name: "imfEmSicIesmrReasonIesmrrList",
        component: emLevelTreeListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfEmSicIesmrReasonIesmrr/edit",
        name: "imfEmSicIesmrReasonIesmrrEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfEmSicIesmrStatusIesmrs/list",
        name: "imfEmSicIesmrStatusIesmrsList",
        component: emLevelTreeListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfEmSicIesmrStatusIesmrs/edit",
        name: "imfEmSicIesmrStatusIesmrsEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/statusCollection/emSicEafmREocEmrecEdit",
        name: "emSicEafmREocEmrecEdit",
        component: emSicEafmREocEmrecEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicEafmREocEmrecList",
        name: "emSicEafmREocEmrecList",
        component: emSicEafmREocEmrecList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/statusCollection/emSicDowntimeRecordSdrList",
        name: "emSicDowntimeRecordSdrList",
        component: emSicDowntimeRecordSdrList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicDowntimeRecordSdrEdit",
        name: "emSicDowntimeRecordSdrEdit",
        component: emSicDowntimeRecordSdrEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfEmSicEqStatusMoniRecoIesmrList",
        name: "imfEmSicEqStatusMoniRecoIesmrList",
        component: imfEmSicEqStatusMoniRecoIesmrList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/imfEmSicEqStatusMoniRecoIesmrEdit",
        name: "imfEmSicEqStatusMoniRecoIesmrEdit",
        component: imfEmSicEqStatusMoniRecoIesmrEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBackgroundImageSbiList",
        name: "emSicBackgroundImageSbiList",
        component: emSicBackgroundImageSbiList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicBackgroundImageSbiEdit",
        name: "emSicBackgroundImageSbiEdit",
        component: emSicBackgroundImageSbiEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicCustomizedDiagramScdEdit",
        name: "emSicCustomizedDiagramScdEdit",
        component: emSicCustomizedDiagramScdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicCustomizedDiagramScdList",
        name: "emSicCustomizedDiagramScdList",
        component: emSicCustomizedDiagramScdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicCustomizedDiagramPieceCdpList",
        name: "emSicCustomizedDiagramPieceCdpList",
        component: emSicCustomizedDiagramPieceCdpList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicCustomizedDiagramPieceCdpEdit",
        name: "emSicCustomizedDiagramPieceCdpEdit",
        component: emSicCustomizedDiagramPieceCdpEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorSpindleLoadTmsList",
        name: "tpmMonitorSpindleLoadTmsList",
        component: tpmMonitorSpindleLoadTmsList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorSpindleLoadTmsEdit",
        name: "tpmMonitorSpindleLoadTmsEdit",
        component: tpmMonitorSpindleLoadTmsEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorProgramStatusTmpList",
        name: "tpmMonitorProgramStatusTmpList",
        component: tpmMonitorProgramStatusTmpList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorProgramStatusTmpEdit",
        name: "tpmMonitorProgramStatusTmpEdit",
        component: tpmMonitorProgramStatusTmpEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeReportTorEdit",
        name: "tpmOeeReportTorEdit",
        component: tpmOeeReportTorEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeReportTorList",
        name: "tpmOeeReportTorList",
        component: tpmOeeReportTorList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeSpindleDataFetchEdit",
        name: "tpmOeeSpindleDataFetchEdit",
        component: tpmOeeSpindleDataFetchEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeSpindleDataFetchList",
        name: "tpmOeeSpindleDataFetchList",
        component: tpmOeeSpindleDataFetchList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeQueryHistoryTohEdit",
        name: "tpmOeeQueryHistoryTohEdit",
        component: tpmOeeQueryHistoryTohEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeQueryHistoryTohList",
        name: "tpmOeeQueryHistoryTohList",
        component: tpmOeeQueryHistoryTohList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeDashboardConfigList",
        name: "tpmOeeDashboardConfigList",
        component: tpmOeeDashboardConfigList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmOeeDashboardConfigEdit",
        name: "tpmOeeDashboardConfigEdit",
        component: tpmOeeDashboardConfigEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorOperateModeTmoList",
        name: "tpmMonitorOperateModeTmoList",
        component: tpmMonitorOperateModeTmoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorOperateModeTmoEdit",
        name: "tpmMonitorOperateModeTmoEdit",
        component: tpmMonitorOperateModeTmoEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorProgramStatusTmoEdit",
        name: "tpmMonitorProgramStatusTmoEdit",
        component: tpmMonitorProgramStatusTmoEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmMonitorProgramStatusTmoList",
        name: "tpmMonitorProgramStatusTmoList",
        component: tpmMonitorProgramStatusTmoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmAxisCoordinateDataAcdList",
        name: "tpmAxisCoordinateDataAcdList",
        component: tpmAxisCoordinateDataAcdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmAxisCoordinateDataAcdEdit",
        name: "tpmAxisCoordinateDataAcdEdit",
        component: tpmAxisCoordinateDataAcdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmTsdOpcConfigTtcEdit",
        name: "tpmTsdOpcConfigTtcEdit",
        component: tpmTsdOpcConfigTtcEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/tpmTsdOpcConfigTtcList",
        name: "tpmTsdOpcConfigTtcList",
        component: tpmTsdOpcConfigTtcList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]
